import { Component, OnInit, ElementRef, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AccountManageService } from '../../services/accountManage.service';
import { CommonComponent } from 'src/app/models/formComponent';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AccountService, UserType, LoginPageManagementService } from 'src/app/services/api.services';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NotifyService } from 'src/app/services/notify.service';
import posthog from 'posthog-js'

@Component({
    selector: 'app-login-cmp',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends CommonComponent implements OnInit, OnDestroy, AfterViewInit {
    baseUrl: string;

    private toggleButton: any;
    private sidebarVisible: boolean;

    loginControl: FormGroup;
    showVideoBackground: boolean;

    loginTitle: string = 'Bonjour';
    loginText: string;
    loginBackgroundImageUrl: string;
    loginBackgroundVideoUrl: string;

    @ViewChild('loginCard') loginCard: ElementRef<HTMLDivElement>;

    constructor(
        private router: Router,
        private accountService: AccountService,
        private translate: TranslateService,
        private accountManagerService: AccountManageService,
        private element: ElementRef,
        private formBuilder: FormBuilder,
        private loginPageManagementService: LoginPageManagementService
    ) {
        super();
        this.sidebarVisible = false;
    }

    login() {
        if (this.loginControl.valid) {
            const ref = this;
            this.accountService.login(this.loginControl.value).subscribe(
                (user) => {
                    this.accountManagerService.login(user);
                    if (user.userType === UserType.Client) {
                        this.router.navigate(['/portal']);
                    } else {
                        posthog.identify(
                            user.personalEmail,
                            {
                                email: user.personalEmail
                            }
                        );
                        this.router.navigate(['/dashboard']);
                    }
                },
                (error) => {
                    console.log(error);
                    if (error.lockedOut) {
                        ref.loginControl.setErrors({ accountLocked: true });
                    }

                    if (error.invalid) {
                        ref.loginControl.setErrors({ failedLogin: true });
                    }
                }
            );
        } else {
            this.validateAllFormFields(this.loginControl);
        }
    }

    switchLanguage() {
        if (this.translate.currentLang === 'en') {
            this.setLanguage('fr');
        } else {
            this.setLanguage('en');
        }
    }

    setLanguage(language: string) {
        this.translate.use(language);
        moment.locale(language);
    }

    ngOnInit() {
        this.loginPageManagementService.loginPage().subscribe((result) => {
            this.loginTitle = result.title != null ? result.title : this.loginTitle;
            this.loginText = result.text != null ? result.text : this.loginText;

            this.showVideoBackground = result.hasVideoBackground;

            if (result.hasVideoBackground && result.backgroundVideo) {
                this.loginBackgroundVideoUrl = result.backgroundVideo.videoUrl;
            } else if (result.backgroundImage) {
                this.loginBackgroundImageUrl = result.backgroundImage.imageUrl;
            } else {
                this.showVideoBackground = false;
                this.loginBackgroundImageUrl = '/assets/img/login-background.jpg'; // default login background
            }
        });

        this.loginControl = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
        });

        this.accountManagerService.logout();
    }

    ngAfterViewInit(): void {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('login-page');
        body.classList.add('off-canvas-sidebar');
        const card = this.loginCard.nativeElement;
        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            card.classList.remove('card-hidden');
        }, 700);
    }

    sidebarToggle() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('navbar-collapse')[0];
        if (this.sidebarVisible === false) {
            setTimeout(function () {
                toggleButton.classList.add('toggled');
            }, 500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        } else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
    }
    ngOnDestroy() {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('login-page');
        body.classList.remove('off-canvas-sidebar');
    }
}

class LoginInfo {
    constructor(public email: string, public password: string) { }
}
